export const SA_8000 = 'SA 8000';
export const AC00_56B = 'AC00-56B';
export const ISO_9001_2015 = 'ISO 9001:2015';
export const ISO_IEC_17021_2006_E = 'ISO/IEC 17021:2006(E)';
export const ISO_9001_2000 = 'ISO 9001:2000';
export const ISO_9001_2008 = 'ISO 9001:2008';
export const OHSAS_18001_2007 = 'OHSAS 18001:2007';
export const ISO_14001_2004 = 'ISO 14001:2004';
export const ISO_14001_2015 = 'ISO 14001:2015';
export const ISO_22000_2005 = 'ISO 22000:2005';
export const ISO_22313_2012 = 'ISO 22313:2012';
export const SNI_19_14001_2005 = 'SNI 19-14001-2005';
export const ISO_26000_2010 = 'ISO 26000:2010';
export const SNI_9001_2008 = 'SNI 9001-2008';
export const ISO_13485_2016 = 'ISO 13485:2016';
export const ISO_IEC_27001_2013 = 'ISO/IEC 27001:2013';
export const AS_9003A = 'AS 9003A';
export const AS_9110C = 'AS 9110C';
export const AS_9100D = 'AS 9100D';
export const AS_9120B = 'AS 9120B';
export const ISO_45001_2018 = 'ISO 45001:2018';
export const UNACCREDITED = 'Unaccredited';
export const AS9110C_2016 = 'AS9110C:2016';
export const GMP = 'GMP';
export const NIST = 'NIST';

export const StandardsWithCompetencies = [
    ISO_13485_2016
]
